<script setup lang="ts">

import { ref } from "vue"

const props = defineProps<{
    maxQuantity: number,
    pickedQuantity: number
}>()

const emits = defineEmits<{
    // eslint-disable-next-line no-unused-vars
    (e: 'update:pickedQuantity', value: number): void
}>()

const hoveredStar = ref<number | null>(null)

const updatePickedQuantity = (value: number) => {
    emits('update:pickedQuantity', value)
}

const handleMouseEnter = (starIndex: number) => {
    hoveredStar.value = starIndex - 1 // Convert to 0-based index
}

const handleMouseLeave = () => {
    hoveredStar.value = null
}

const handleStarClick = (starIndex: number) => {
    updatePickedQuantity(starIndex) // Keep 1-based for the prop
}

const shouldFillStar = (starIndex: number) => {
    const zeroBasedIndex = starIndex - 1
    const targetIndex = hoveredStar.value !== null ? hoveredStar.value : props.pickedQuantity - 1
    return zeroBasedIndex <= targetIndex
}

</script>

<template>
    <div class="star-picker-container">
        <div class="star-picker-container__stars" @mouseleave="handleMouseLeave">
            <svg 
                v-for="i in props.maxQuantity" 
                :key="i" 
                width="24px" 
                height="24px" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                class="star-svg"
                :class="{ 'star-filled': shouldFillStar(i) }"
                @mouseenter="handleMouseEnter(i)"
                @click="handleStarClick(i)"
            >
                <rect width="24" height="24" />
                <path
                    d="M11.5245 4.46353C11.6741 4.00287 12.3259 4.00287 12.4755 4.46353L13.9084 8.87336C13.9753 9.07937 14.1673 9.21885 14.3839 9.21885H19.0207C19.505 9.21885 19.7064 9.83866 19.3146 10.1234L15.5633 12.8488C15.3881 12.9761 15.3148 13.2018 15.3817 13.4078L16.8145 17.8176C16.9642 18.2783 16.437 18.6613 16.0451 18.3766L12.2939 15.6512C12.1186 15.5239 11.8814 15.5239 11.7061 15.6512L7.95488 18.3766C7.56303 18.6613 7.03578 18.2783 7.18546 17.8176L8.6183 13.4078C8.68524 13.2018 8.61191 12.9761 8.43667 12.8488L4.68544 10.1234C4.29358 9.83866 4.49497 9.21885 4.97933 9.21885H9.6161C9.83272 9.21885 10.0247 9.07937 10.0916 8.87336L11.5245 4.46353Z"
                    stroke="#ffe018" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                />
            </svg>
        </div>
    </div>
</template>

<style lang="scss">
@import "../../styles/core/variables.scss";


.star-picker-container__stars{
    display: flex;
    align-items: center;
    cursor: pointer;
}

.star-svg {
    transition: fill 0.2s ease;
}

.star-svg path {
    stroke: $scheme-yellow !important;
}

.star-svg:hover {
    transform: scale(1.1);
}

.star-filled path {
    fill: $scheme-yellow;
    stroke: $scheme-yellow;
}

</style>